/**
 * Set activityLog data.
 *
 * @param state
 * @param payload
 */
export function SET_ACTIVITY_LOG_DATA(state, payload) {
  state.activityLogData = payload.data;
  state.meta = payload.meta;
}